import React from "react";
import styled from "styled-components";
import { rgba } from "polished";
import Slider from "rc-slider";
const StyledSlider = styled(Slider)`
  & .rc-slider-rail,
  & .rc-slider-track {
    height: 10px;
    border-radius: 5px;
  }

  & .rc-slider-rail {
    background: ${p => rgba(p.theme.colorSuccessText || "white", 0.3)};
  }

  & .rc-slider-track {
    background: ${p => p.theme.colorSuccessText};
  }

  & .rc-slider-handle {
    width: 28px;
    height: 28px;
    top: 0;
    background: ${p => p.theme.colorSuccessText};
    border: 4px solid ${p => p.theme.colorSuccessText};
    box-shadow: 0px 0px 6px
      ${p => rgba(p.theme.colorSuccess || "transparent", 0.5)};
  }
`;

const Wrapper = ({
  setFieldValue,
  value
}) => {
  return /*#__PURE__*/React.createElement(StyledSlider, {
    min: 5,
    max: 25,
    step: 5,
    value: value,
    onChange: e => setFieldValue("amount", e.toFixed(2))
  });
};

export default Wrapper;